'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (pipSize) {
    if (isNaN(pipSize)) {
        return '0.01';
    }
    var zeros = Array(pipSize).join('0');
    return '0.' + zeros + 1;
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/number/pipSizeToStepSize.js
// module id = 105
// module chunks = 0